<template>
  <div class="detail_content">
    <div class="assessment_title_label">
      {{titleLabel}}
    </div>
    <div :class='nameValue' class='detail_content'>
      <div class='tenant_radio_buttons'>
        <label>
          <input type='radio' class='tenant_radio_button'
                              :name='nameValue'
                              value='true'
                              @click='changeFlag()'
                              checked>
          {{onlabel}}
        </label>
        <label>
          <input type='radio' class='tenant_radio_button'
                              :name='nameValue'
                              value='false'
                              @click='changeFlag()'>
          {{offlabel}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    nameValue: String
  },
  data () {
    return {
      onlabel: 'DBデータ',
      offlabel: '集計データ'
    }
  },
  computed: {
  },
  methods: {
    changeFlag () {
      this.$emit('changeFlag')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/logExportCompornents/radioButtonSection.vue